'use client';

import Footer from '@components/footer';
import { usePreview } from 'cms/clients/sanity.preview';
import contactInformationQuery from 'queries/contact-information-query';
import siteSettingsQuery from 'queries/site-settings-query';
import type { ReactElement } from 'react';
import React from 'react';
import type ContactInformation from 'types/contact-information';
import type { SiteSettings } from 'types/site-settings';

export default function PreviewFooter(): ReactElement {
  const siteSettings: SiteSettings | null =
    usePreview<SiteSettings>(siteSettingsQuery);

  const contactInformation: ContactInformation | null =
    usePreview<ContactInformation>(contactInformationQuery);

  if (siteSettings === null) {
    throw new Error('Could not find SiteSettings');
  }

  if (contactInformation === null) {
    throw new Error('Could not find ContactInformation');
  }

  return (
    <Footer
      contactInformation={contactInformation}
      siteSettings={siteSettings}
    />
  );
}
